interface MetaConfig {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl: string;
}

interface MetaConfigMap {
  [key: string]: MetaConfig;
}

const metaConfig: MetaConfigMap = {
  home: {
    title: "Counselling & Therapy in Surrey, BC | Metro Counselling",
    description: "Professional counselling and therapy in Surrey, BC. Individual, couples, family, anxiety, depression, trauma, and ICBC counselling with registered clinical counsellors.",
    keywords: "counselling Surrey, therapy Surrey, counsellor Surrey BC, mental health Surrey, ICBC counselling, marriage counselling, anxiety therapy",
    canonicalUrl: "/"
  },
  'meet-our-counsellors': {
    title: "Meet Our Counsellors in Surrey, BC | Metro Counselling",
    description: "Meet the registered clinical counsellors and therapists at Metro Counselling in Surrey, BC. Multilingual team specializing in trauma, anxiety, depression, and couples therapy.",
    keywords: "counsellors Surrey, therapists Surrey BC, registered clinical counsellor, RCC, multilingual counsellor",
    canonicalUrl: "/meet-our-counsellors"
  },
  'contact-us': {
    title: "Contact Metro Counselling in Surrey, BC | Book a Session",
    description: "Contact Metro Counselling at 604-619-9992. Located at 201-10366 136A Street, Surrey, BC V3T 1W4. Book your counselling session today.",
    keywords: "contact Metro Counselling, book counselling Surrey, counselling appointment Surrey BC",
    canonicalUrl: "/contact-us"
  },
  services: {
    title: "Counselling Services in Surrey, BC | Metro Counselling",
    description: "Comprehensive counselling services in Surrey: individual, couples, family, anxiety, depression, trauma, grief, anger management, and child counselling.",
    keywords: "counselling services Surrey, therapy services Surrey BC, mental health services",
    canonicalUrl: "/services"
  },
  'other-wellness-therapies': {
    title: "Wellness Therapies in Surrey, BC | Metro Counselling",
    description: "Holistic wellness therapies in Surrey: Holy Fire Reiki, oxygen therapy, Indian head massage, and therapeutic touch. Mind-body care alongside counselling.",
    keywords: "wellness therapy Surrey, Reiki Surrey, oxygen therapy, Indian head massage Surrey, holistic healing",
    canonicalUrl: "/other-wellness-therapies"
  },
  blog: {
    title: "Mental Health & Wellness Blog | Metro Counselling Surrey",
    description: "Expert articles on mental health, anxiety, depression, trauma, relationships, and personal growth from Surrey's registered clinical counsellors.",
    keywords: "mental health blog, counselling articles Surrey, therapy insights, wellness blog BC",
    canonicalUrl: "/blog"
  },
  developers: {
    title: "Developer & Agent Documentation | Metro Counselling",
    description: "How automated agents can read Metro Counselling's public pages: OpenAPI description, llms.txt, Markdown content negotiation, and structured JSON error responses.",
    keywords: "Metro Counselling openapi, llms.txt, agent documentation, markdown content negotiation",
    canonicalUrl: "/developers"
  },
  career: {
    title: "Counselling & Therapy Careers in Surrey, BC | Metro Counselling",
    description: "Join the Metro Counselling team in Surrey, BC. Career opportunities for registered clinical counsellors and mental health professionals.",
    keywords: "counselling jobs Surrey, RCC jobs BC, therapist careers Surrey, mental health employment",
    canonicalUrl: "/career"
  },
  'individual-counselling-therapy-surrey': {
    title: "Individual Counselling & Therapy in Surrey, BC | Metro Counselling",
    description: "Professional one-on-one counselling in Surrey, BC. Personalized therapy for anxiety, depression, stress, life transitions, and personal growth with experienced RCCs.",
    keywords: "individual counselling Surrey, personal therapy Surrey BC, one-on-one counselling, individual therapist Surrey",
    canonicalUrl: "/individual-counselling-therapy-surrey"
  },
  'couples-therapy-marriage-counselling-surrey': {
    title: "Marriage Counselling & Couples Therapy in Surrey, BC",
    description: "Expert marriage counselling and couples therapy in Surrey, BC. Strengthen communication, rebuild trust, and resolve conflict with registered clinical counsellors.",
    keywords: "marriage counselling Surrey, couples therapy Surrey BC, relationship counselling, marriage therapist Surrey",
    canonicalUrl: "/couples-therapy-marriage-counselling-surrey"
  },
  'mental-health-counselling-surrey': {
    title: "Mental Health Counselling in Surrey, BC | Metro Counselling",
    description: "Comprehensive mental health counselling in Surrey, BC. Professional support for anxiety, depression, trauma, and other mental health concerns.",
    keywords: "mental health counselling Surrey, mental health therapy Surrey BC, psychological support",
    canonicalUrl: "/mental-health-counselling-surrey"
  },
  'holy-fire-reiki-therapy-surrey': {
    title: "Holy Fire Reiki Therapy in Surrey, BC | Metro Counselling",
    description: "Experience Holy Fire Reiki energy healing in Surrey, BC. Professional Reiki therapy for physical and emotional well-being.",
    keywords: "Reiki Surrey, Holy Fire Reiki Surrey BC, energy healing Surrey, Reiki therapy",
    canonicalUrl: "/holy-fire-reiki-therapy-surrey"
  },
  'oxygen-therapy-surrey': {
    title: "Oxygen Therapy in Surrey, BC | Metro Counselling",
    description: "Professional oxygen therapy in Surrey, BC. Wellness and recovery support through oxygen therapy treatment.",
    keywords: "oxygen therapy Surrey, oxygen treatment Surrey BC, wellness therapy",
    canonicalUrl: "/oxygen-therapy-surrey"
  },
  'indian-head-massage-therapy-surrey': {
    title: "Indian Head Massage Therapy in Surrey, BC",
    description: "Traditional Indian head massage therapy in Surrey, BC. Stress relief, relaxation, and improved well-being.",
    keywords: "Indian head massage Surrey, head massage therapy Surrey BC, relaxation therapy",
    canonicalUrl: "/indian-head-massage-therapy-surrey"
  },
  'child-counselling-services-surrey': {
    title: "Child Counselling Services in Surrey, BC | Metro Counselling",
    description: "Specialized child counselling and therapy in Surrey, BC. Professional support for children's mental health, anxiety, behaviour, and development.",
    keywords: "child counselling Surrey, child therapist Surrey BC, children's mental health, youth therapy",
    canonicalUrl: "/child-counselling-services-surrey"
  },
  'anxiety-stress-management-counselor-in-surrey': {
    title: "Anxiety & Stress Counselling in Surrey, BC | Metro Counselling",
    description: "Anxiety and stress management counselling in Surrey, BC. Evidence-based therapy with experienced counsellors. Find relief and develop coping strategies.",
    keywords: "anxiety counselling Surrey, stress management Surrey BC, anxiety therapist Surrey, anxiety therapy",
    canonicalUrl: "/anxiety-stress-management-counselor-in-surrey"
  },
  'depression-treatment-counsellors-in-surrey': {
    title: "Depression Counselling & Treatment in Surrey, BC",
    description: "Expert depression counselling and treatment in Surrey, BC. Professional support, evidence-based therapy, and compassionate care from registered clinical counsellors.",
    keywords: "depression counselling Surrey, depression treatment Surrey BC, depression therapist, mood disorders",
    canonicalUrl: "/depression-treatment-counsellors-in-surrey"
  },
  'post-traumatic-stress-disorder-counsellors': {
    title: "PTSD & Trauma Counselling in Surrey, BC | Metro Counselling",
    description: "Professional PTSD and trauma counselling in Surrey, BC. Specialized therapy for post-traumatic stress, ICBC trauma claims, and trauma recovery.",
    keywords: "PTSD counselling Surrey, trauma therapy Surrey BC, ICBC trauma counselling, PTSD therapist",
    canonicalUrl: "/post-traumatic-stress-disorder-counsellors"
  },
  'anger-management-counselling-surrey': {
    title: "Anger Management Counselling in Surrey, BC",
    description: "Professional anger management counselling in Surrey, BC. Learn effective strategies to manage anger and regulate emotions with experienced counsellors.",
    keywords: "anger management Surrey, anger counselling Surrey BC, emotional regulation, anger therapist",
    canonicalUrl: "/anger-management-counselling-surrey"
  },
  'womens-issues-counsellors-in-surrey': {
    title: "Women's Counselling in Surrey, BC | Metro Counselling",
    description: "Counselling for women in Surrey, BC. Professional support for women's mental health, life transitions, relationships, and personal well-being.",
    keywords: "women's counselling Surrey, women's therapy Surrey BC, women's mental health, female counsellor",
    canonicalUrl: "/womens-issues-counsellors-in-surrey"
  },
  'grief-counselling-support-surrey': {
    title: "Grief Counselling & Bereavement Support in Surrey, BC",
    description: "Compassionate grief counselling and bereavement support in Surrey, BC. Professional help navigating loss, mourning, and healing.",
    keywords: "grief counselling Surrey, bereavement support Surrey BC, loss counselling, grief therapy",
    canonicalUrl: "/grief-counselling-support-surrey"
  },
  'family-therapy-counselling-services-in-surrey': {
    title: "Family Therapy & Counselling in Surrey, BC",
    description: "Professional family therapy and counselling in Surrey, BC. Strengthen family bonds, resolve conflicts, and improve communication with experienced therapists.",
    keywords: "family therapy Surrey, family counselling Surrey BC, family therapist, parent-child counselling",
    canonicalUrl: "/family-therapy-counselling-services-in-surrey"
  },
  'lgbtq-counselling': {
    title: "LGBTQ+ Counselling in Surrey, BC | Metro Counselling",
    description: "Affirming LGBTQ+ counselling in Surrey, BC. Inclusive, professional support in a safe and welcoming environment for queer, trans, and non-binary clients.",
    keywords: "LGBTQ counselling Surrey, queer therapy Surrey BC, gender therapy, LGBTQ+ counsellor",
    canonicalUrl: "/lgbtq-counselling"
  },
  'icbc-coverage-and-other-coverage': {
    title: "ICBC Counselling Coverage in Surrey, BC | Metro Counselling",
    description: "ICBC counselling and trauma therapy in Surrey, BC. Direct billing, 12 free sessions, and specialized support for accident-related anxiety, PTSD, and grief.",
    keywords: "ICBC counselling Surrey, ICBC direct billing, ICBC trauma therapy, accident counselling Surrey BC",
    canonicalUrl: "/icbc-coverage-and-other-coverage"
  },
  'tele-health-system': {
    title: "Online Counselling & Telehealth Therapy in Surrey, BC",
    description: "Secure online counselling and telehealth therapy across British Columbia. Virtual sessions with registered clinical counsellors from the comfort of home.",
    keywords: "online counselling BC, telehealth therapy Surrey, virtual counselling, online therapist BC",
    canonicalUrl: "/tele-health-system"
  },
  'counsellor-kristina-sohal': {
    title: "Kristina Sohal, RCC | Counsellor in Surrey, BC | Metro Counselling",
    description: "Kristina Sohal, Registered Clinical Counsellor at Metro Counselling Surrey. Specializing in CBT, mindfulness, and solution-focused therapy. English and Punjabi.",
    keywords: "Kristina Sohal, Punjabi counsellor Surrey, RCC Surrey BC, CBT therapist, mindfulness therapy",
    canonicalUrl: "/counsellor/kristina-sohal"
  },
  'counsellor-sarvenaz-amiri': {
    title: "Sarvenaz Amiri, RCC | Counsellor in Surrey, BC | Metro Counselling",
    description: "Sarvenaz Amiri, Registered Clinical Counsellor at Metro Counselling Surrey. Trauma-informed, client-centered care for anxiety, depression, and PTSD in English and Farsi.",
    keywords: "Sarvenaz Amiri, Farsi counsellor Surrey, Persian therapist, RCC Surrey BC, trauma therapy, CBT",
    canonicalUrl: "/counsellor/sarvenaz-amiri"
  },
  'counsellor-cynthia-csepregi': {
    title: "Cynthia Csepregi, RCC, MSW | Counsellor in Surrey, BC | Metro Counselling",
    description: "Cynthia Csepregi, RCC and Social Worker at Metro Counselling Surrey. 14+ years experience in mental health, crisis intervention, and supporting positive change.",
    keywords: "Cynthia Csepregi, social worker Surrey, RCC Surrey BC, crisis intervention, MSW counsellor",
    canonicalUrl: "/counsellor/cynthia-csepregi"
  },
  'counsellor-fatemeh-poorrezvan': {
    title: "Fatemeh Poorrezvan, RCC | Counsellor in Surrey, BC | Metro Counselling",
    description: "Fatemeh Poorrezvan, Registered Clinical Counsellor at Metro Counselling Surrey. Counselling in English, Farsi, and Turkish.",
    keywords: "Fatemeh Poorrezvan, Farsi counsellor Surrey, Turkish therapist, RCC Surrey BC",
    canonicalUrl: "/counsellor/fatemeh-poorrezvan"
  },
  'counsellor-rafael-tejada': {
    title: "Rafael Tejada, RCC | Counsellor in Surrey, BC | Metro Counselling",
    description: "Rafael Tejada, Registered Clinical Counsellor at Metro Counselling Surrey. Compassionate professional support for your mental health journey.",
    keywords: "Rafael Tejada, counsellor Surrey, RCC Surrey BC, mental health counselling",
    canonicalUrl: "/counsellor/rafael-tejada"
  },
  'counsellor-beth-mares': {
    title: "Beth Mares | Self-Care Coach & Therapeutic Touch | Metro Counselling Surrey",
    description: "Beth Mares, Self-Care Coach and Therapeutic Touch Practitioner at Metro Counselling Surrey. Holistic wellness, Reiki, and therapeutic touch.",
    keywords: "Beth Mares, self-care coach Surrey, therapeutic touch, Reiki Surrey, holistic wellness",
    canonicalUrl: "/counsellor/beth-mares"
  },
  'counsellor-albin-issac': {
    title: "Albin Issac, RCC | Counsellor in Surrey, BC | Metro Counselling",
    description: "Albin Issac, Registered Clinical Counsellor at Metro Counselling Surrey. Professional counselling support for your mental health journey.",
    keywords: "Albin Issac, counsellor Surrey, RCC Surrey BC, mental health counselling",
    canonicalUrl: "/counsellor/albin-issac"
  },
  'counsellor-karen-gorseth': {
    title: "Karen Gorseth, RCC | Counsellor in Surrey, BC | Metro Counselling",
    description: "Karen Gorseth, Registered Clinical Counsellor at Metro Counselling Surrey. Professional counselling support for your mental health journey.",
    keywords: "Karen Gorseth, counsellor Surrey, RCC Surrey BC, mental health counselling",
    canonicalUrl: "/counsellor/karen-gorseth"
  },
};

export const getMetaConfig = (page: string, pathname = '/'): MetaConfig => {
  const config = metaConfig[page];
  if (!config) {
    return {
      title: "Counselling & Therapy in Surrey, BC | Metro Counselling",
      description: "Professional counselling and therapy services in Surrey, BC. Individual, couples, family, and specialized mental health support.",
      keywords: "counselling Surrey, therapy Surrey BC, mental health Surrey",
      // Fall back to the live path: an unconfigured route must never declare
      // itself a duplicate of the homepage.
      canonicalUrl: pathname
    };
  }
  return config;
};

export default metaConfig;
